"use client"
import React, { useState } from 'react'
import { Tabs, Tab } from "react-bootstrap";
import { Container, Row, Col, Image } from "react-bootstrap";
import { IoImageOutline } from "react-icons/io5";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

const Gallerey = () => {
    const [showGallery, setShowGallery] = useState(false);
    const [startIndex, setStartIndex] = useState(0);
    const [key, setKey] = useState("photo");
    const galleryItems = [
        {
            original: "/images/gallery1.jpg",
            thumbnail: "/images/gallery1.jpg",
            description: "വിജിലൻസ് ഓഫീസ് സന്ദർശനം"
        },
        {
            original: "/images/gallery2.jpg",
            thumbnail: "/images/gallery2.jpg",
            description: "Closing Ceremony – 1st Kannur Rural Police Annual Games"
        },
        {
            original: "/images/gallery3.png",
            thumbnail: "/images/gallery3.png",
            description: "Commemoration Day 2022"
        },
        {
            original: "/images/gallery4.png",
            thumbnail: "/images/gallery4.png",
            description: "Commemoration Day 2022"
        },
        {
            original: "/images/gallery1.jpg",
            thumbnail: "/images/gallery1.jpg",
            description: "വിജിലൻസ് ഓഫീസ് സന്ദർശനം"
        },
        {
            original: "/images/gallery2.jpg",
            thumbnail: "/images/gallery2.jpg",
            description: "Closing Ceremony – 1st Kannur Rural Police Annual Games"
        },
        {
            original: "/images/gallery3.png",
            thumbnail: "/images/gallery3.png",
            description: "Commemoration Day 2022"
        },
        {
            original: "/images/gallery4.png",
            thumbnail: "/images/gallery4.png",
            description: "Commemoration Day 2022"
        },
        {
            original: "/images/gallery1.jpg",
            thumbnail: "/images/gallery1.jpg",
            description: "വിജിലൻസ് ഓഫീസ് സന്ദർശനം"
        },
        {
            original: "/images/gallery2.jpg",
            thumbnail: "/images/gallery2.jpg",
            description: "Closing Ceremony – 1st Kannur Rural Police Annual Games"
        },
        {
            original: "/images/gallery3.png",
            thumbnail: "/images/gallery3.png",
            description: "Commemoration Day 2022"
        },
        {
            original: "/images/gallery4.png",
            thumbnail: "/images/gallery4.png",
            description: "Commemoration Day 2022"
        }
    ];

    const albums = [
        {
            id: 1,
            title: "വിജിലൻസ് ഓഫീസ് സന്ദർശനം",
            photos: [
                "/images/gallery1.jpg",
                "/images/gallery1.Jpg",
                "/images/gallery1.jpg",
                
            ],
        },
        {
            id: 2,
            title: "Closing Ceremony – 1st Kannur Rural Police Annual Games",
            photos: [
                "/images/gallery2.jpg",
                "/images/gallery2.jpg",
                "/images/gallery2.jpg",
            ],
        },
        {
            id: 3,
            title: "Commemoration Day 2022",
            photos: [
                "/images/gallery3.png",
                "/images/gallery3.png",
                "/images/gallery3.png",
            ],
        },
         {
            id: 4,
            title: "Commemoration Day 2022",
            photos: [
                "/images/gallery4.png",
                "/images/gallery4.png",
                "/images/gallery4.png",
            ],
        },
           {
            id: 5,
            title: "വിജിലൻസ് ഓഫീസ് സന്ദർശനം",
            photos: [
                "/images/gallery1.jpg",
                "/images/gallery1.Jpg",
                "/images/gallery1.jpg",
            ],
        },
        {
            id: 6,
            title: "Closing Ceremony – 1st Kannur Rural Police Annual Games",
            photos: [
                "/images/gallery2.jpg",
                "/images/gallery2.jpg",
                "/images/gallery2.jpg",
            ],
        },
        {
            id: 7,
            title: "Commemoration Day 2022",
            photos: [
                "/images/gallery3.png",
                "/images/gallery3.png",
                "/images/gallery3.png",
            ],
        },
         {
            id: 8,
            title: "Commemoration Day 2022",
            photos: [
                "/images/gallery4.png",
                "/images/gallery4.png",
                "/images/gallery4.png",
            ],
        },
     
     
    ];

    const [open, setOpen] = useState(false);
    const [activeAlbum, setActiveAlbum] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0);


    function openAlbum(album, startIndex = 0) {
        setActiveAlbum(album);
        setActiveIndex(startIndex);
        setOpen(true);
        document.body.style.overflow = "hidden";
    }


    function closeAlbum() {
        setOpen(false);
        setActiveAlbum(null);
        setActiveIndex(0);
        document.body.style.overflow = "";
    }


    function prev() {
        setActiveIndex((i) => (i - 1 + activeAlbum.photos.length) % activeAlbum.photos.length);
    }


    function next() {
        setActiveIndex((i) => (i + 1) % activeAlbum.photos.length);
    }
    return (
        <>

            <div className="tabs-container mt-40">
                <Tabs
                    id="section-tabs"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                    className="custom-tabs"
                >
                    <Tab eventKey="photo" title="Photos" className='mt-40'>
                        <>
                            <div className="gallery-grid">
                                {albums.map((album) => (
                                    <div
                                        key={album.id}
                                        className="gallery-card"
                                        onClick={() => openAlbum(album, 0)}
                                    >
                                        <div className="">
                                            <img
                                                src={album.photos[0]}
                                                alt={album.title}
                                                className="w-full h-full object-cover"
                                                loading="lazy"
                                            />

                                            <div className="gallery-text">{album.title}</div>
                                            {/* <span className="image-icon-gallery-span">
                                                <IoImageOutline className="icon-gallery" />
                                            </span> */}
                                            <div className="gallery-text"> {album.photos.length} photos</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {open && activeAlbum && (
                                <div className="album-modal">
                                    <div className="album-backdrop" onClick={closeAlbum}></div>

                                    <div className="album-dialog">
                                        {/* Header */}
                                        <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
                                            <h3 className="mb-0">{activeAlbum.title}</h3>
                                            <button
                                                onClick={closeAlbum}
                                                className="btn-close"
                                                aria-label="Close"
                                            ></button>
                                        </div>

                                        {/* Body */}
                                        <div className="d-flex flex-column flex-md-row">
                                            {/* Main image */}
                                            <div className="album-main flex-grow-1 d-flex align-items-center justify-content-center position-relative bg-dark">
                                                <button
                                                    onClick={prev}
                                                    className="album-nav-btn position-absolute start-0 top-50 translate-middle-y"
                                                    aria-label="Previous"
                                                >
                                                    ◀
                                                </button>

                                                <img
                                                    src={activeAlbum.photos[activeIndex]}
                                                    alt={`photo-${activeIndex}`}
                                                    className="album-img"
                                                />

                                                <button
                                                    onClick={next}
                                                    className="album-nav-btn position-absolute end-0 top-50 translate-middle-y"
                                                    aria-label="Next"
                                                >
                                                    ▶
                                                </button>
                                            </div>

                                            {/* Thumbnails */}
                                            <div className="album-thumbs bg-light p-3 overflow-auto">
                                                {activeAlbum.photos.map((p, idx) => (
                                                    <button
                                                        key={p + idx}
                                                        onClick={() => setActiveIndex(idx)}
                                                        className={`thumb-btn mb-2 border ${idx === activeIndex ? "active-thumb" : ""}`}
                                                    >
                                                        <img src={p} alt={`thumb-${idx}`} className="img-fluid" />
                                                    </button>
                                                ))}
                                            </div>
                                        </div>

                                        {/* Footer */}
                                        <div className="p-3 border-top text-muted text-center">
                                            {activeIndex + 1} / {activeAlbum.photos.length}
                                        </div>
                                    </div>
                                </div>
                            )}

                        </>

                    </Tab>
                    <Tab eventKey="video" title="Videos" className='mt-40'>
                        <div className="gallery-grid">
                            <div className="gallery-card">
                                <img src="/images/gallery3.png" alt="Event Image" />
                                <div className="gallery-text">Commemoration Day 2022</div>
                                <img className='gallery-youtube' src="/icons/youtue1.svg" />
                            </div>
                            <div className="gallery-card">
                                <img src="/images/gallery4.png" alt="Event Image" />
                                <div className="gallery-text">Commemoration Day 2022</div>
                                <img className='gallery-youtube' src="/icons/youtue1.svg" />

                            </div>
                            <div className="gallery-card">
                                <img src="/images/gallery1.jpg" alt="Event Image" />
                                <div className="gallery-text">വിജിലൻസ് ഓഫീസ് സന്ദർശനം</div>
                                <img className='gallery-youtube' src="/icons/youtue1.svg" />
                            </div>
                            <div className="gallery-card">
                                <img src="/images/gallery2.jpg" alt="Event Image" />
                                <div className="gallery-text">Closing Ceremony – 1st Kannur Rural Police Annual Games</div>
                                <img className='gallery-youtube' src="/icons/youtue1.svg" />

                            </div>
                            <div className="gallery-card">
                                <img src="/images/gallery1.jpg" alt="Event Image" />
                                <div className="gallery-text">വിജിലൻസ് ഓഫീസ് സന്ദർശനം</div>
                                <img className='gallery-youtube' src="/icons/youtue1.svg" />

                            </div>
                            <div className="gallery-card">
                                <img src="/images/gallery2.jpg" alt="Event Image" />
                                <div className="gallery-text">Closing Ceremony – 1st Kannur Rural Police Annual Games</div>
                                <img className='gallery-youtube' src="/icons/youtue1.svg" />

                            </div>
                            <div className="gallery-card">
                                <img src="/images/gallery3.png" alt="Event Image" />
                                <div className="gallery-text">Commemoration Day 2022</div>
                                <img className='gallery-youtube' src="/icons/youtue1.svg" />

                            </div>
                            <div className="gallery-card">
                                <img src="/images/gallery4.png" alt="Event Image" />
                                <div className="gallery-text">Commemoration Day 2022</div>
                                <img className='gallery-youtube' src="/icons/youtue1.svg" />

                            </div>
                        </div>
                    </Tab>

                </Tabs>
            </div>



        </>
    )
}

export default Gallerey
